import OLTileLayer from 'ol/layer/Tile';
import BingMaps from 'ol/source/BingMaps';
import OSM from 'ol/source/OSM';
import XYZ from 'ol/source/XYZ';
import { useEffect } from 'react';
import { MAP_EVENTS } from '../constants';
import { PREDEFINED_LAYERS } from '../constants/layerTypes';

// TODO: if we have a million, please refactor this
function getPredefinedLayers({
  source,
  sourceSettings = undefined
}) {
  // source is a function, we need to call it to get the "source" for layer
  if (typeof source === 'function') {
    return source(sourceSettings);
  }

  // TODO: if they are all the same, use a map
  switch (source) {
    case PREDEFINED_LAYERS.BING:
      return new BingMaps(sourceSettings);
    case PREDEFINED_LAYERS.OSM:
      return new OSM(sourceSettings);
    case PREDEFINED_LAYERS.XYZ:
      return new XYZ(sourceSettings);
    default:
      throw new Error(`Unknown layer source for tile layer: ${source}`);
  }
}
const GenericTileLayer = ({
  map,
  name,
  zIndex,
  layer
}) => {
  useEffect(() => {
    if (!map) {
      return;
    }
    const tileLayer = new OLTileLayer({
      projection: 'EPSG:23700',
      source: getPredefinedLayers(layer),
      zIndex,
      properties: {
        name
      }
    });
    map.addLayer(name, tileLayer, layer.defaultVisibility);
    tileLayer.setZIndex(zIndex);
    const visibilityListener = map.addEventListener(MAP_EVENTS.visibilityChange, () => {
      tileLayer.setVisible(map.getLayerVisibility(name));
    });

    // eslint-disable-next-line consistent-return
    return () => {
      if (!map) {
        return;
      }
      map.removeEventListener(MAP_EVENTS.visibilityChange, visibilityListener);
      map.removeLayer(tileLayer);
    };
  }, [map]);

  // this is a HOC
  return null;
};
export default GenericTileLayer;